import React, { useEffect, useState } from "react";
import "./casa-abierta.css";
import { getTarjetasInicio } from "../../config/services/strapi/home";
import { getCasaAbiertaDetalle } from "../../config/services/strapi/casa-abierta";
import TextSkeleton from "../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../components/Skeleton/ImageSkeleton";

export default function CasaAbierta() {
  const [heroData, setHeroData] = useState<any>(null);
  const [detalleData, setDetalleData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const [tarjetas, detalle] = await Promise.all([
          getTarjetasInicio(),
          getCasaAbiertaDetalle(),
        ]);

        const tarjetaHero = tarjetas.find((t: any) => t.titulo === "CASA ABIERTA");
        setHeroData(tarjetaHero);

        if (detalle && detalle.length > 0) {
          setDetalleData(detalle[0]);
        }
      } catch (error) {
        console.error("Error cargando datos dinámicos:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);


  return (
    <>
      <section className="section-casa-abierta">
        <div className="section-inner-casa-abierta">

          <div className="col-media-casa-abierta" style={{ position: 'relative', overflow: 'hidden' }}>
            {loading ? (
              <ImageSkeleton className="h-full" />
            ) : (
              <div
                className="media-cover-casa-abierta"
                style={{
                  backgroundImage: heroData?.portada?.url ? `url(${heroData.portada.url})` : "none",
                  backgroundBlendMode: "overlay"
                }}
              />
            )}
          </div>

          <div className="col-text-casa-abierta casa-abierta">
            {loading ? <TextSkeleton /> : <h1>{heroData?.titulo || "CASA ABIERTA"}</h1>}
          </div>

        </div>
      </section>

      <section className="section-detalles-casa-abierta">
        <div className="contenedor-casa-abierta detalle-inner-casa-abierta">

          <div className="col-izquierda-casa-abierta">
            {/* <div className="wrapper-imagen-casa-abierta">
              {loading ? (
                <ImageSkeleton className="h-full" />
              ) : (
                <div
                  className="capa-imagen-fondo-casa-abierta"
                  style={{
                    backgroundImage: detalleData?.portada?.url
                      ? `url(${detalleData.portada.url})`
                      : "none"
                  }}
                />
              )}
              <div className="overlay-blanco-casa-abierta" />
            </div> */}
          </div>

          <div className="col-derecha-casa-abierta">
            <div className="texto-p-casa-abierta">
              {loading ? (
                <TextSkeleton />
              ) : (
                detalleData?.descripcion?.map((block: any, i: number) => {
                  const text = block.children?.map((c: any) => c.text).join("");
                  return text ? <p key={i}>{text}</p> : null;
                })
              )}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}